import winston from 'winston';
export { setLevel } from './plugins/setLevel/setLevel.js';
import { setPrefix } from './plugins/setPrefix/setPrefix.js';
import { redact } from './redact/redact.js';

/**
 * Indicates whether the application is running in production mode.
 */ const isProd = process.env.NODE_ENV === 'production';
/**
 * Indicates whether the application is running in test mode.
 */ const isTest = process.env.NODE_ENV === 'test';
/**
 * Indicates whether logger formatting should be enabled.
 * Logger formatting is always enabled in production mode and test mode.
 */ const hasFormat = isProd || isTest;
/**
 * The minimum log level to output.
 * In production mode, the log level is set to 'info'.
 * In non-production mode, it defaults to 'debug' for more verbose logging.
 */ const level = isProd ? 'info' : 'debug';
/**
 * Create a new logger with custom options.
 */ const createLogger = ({ keysToRedact = [], prefix, plugins = [] } = {})=>{
    /**
     * Logger Format.
     */ const format = hasFormat ? winston.format.combine(setPrefix({
        prefix
    }), ...plugins, redact(keysToRedact)(), winston.format.uncolorize(), winston.format.timestamp(), winston.format.json()) : winston.format.prettyPrint();
    return winston.createLogger({
        level,
        format,
        defaultMeta: {
            service: `${process.env.ENV ?? 'unknown'}.${process.env.SERVICE_NAME ?? 'service'}`
        },
        transports: [
            new winston.transports.Console({
                silent: isTest,
                forceConsole: true
            })
        ]
    });
};
/**
 * Create Logger.
 */ const logger = createLogger();

export { createLogger, logger, setPrefix };
//# sourceMappingURL=index.js.map
